import { render, staticRenderFns } from "./select-tech-part.vue?vue&type=template&id=f789457c&scoped=true"
import script from "./select-tech-part.vue?vue&type=script&lang=js"
export * from "./select-tech-part.vue?vue&type=script&lang=js"
import style0 from "./select-tech-part.vue?vue&type=style&index=0&id=f789457c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f789457c",
  null
  
)

export default component.exports